import React from 'react';
import { useStateValue } from '../../store/store';

const CircularLoader = () => {
    const [{ importPercent }] = useStateValue();

    var d = 100,
        r = 50,
        circlePi = Math.PI * (r * 2),
        offset = ((100 - importPercent) / 100) * circlePi;

    return (
        <div className="ist-circular-loader">
            <div className="ist-percent-wrap">
                <div className="ist-percent-counter">{importPercent}%</div>
            </div>
            <div className="ist-svg-wrap" data-number={importPercent}>
                <svg className="svg" viewBox={`0 0 ${d} ${d}`} version="1.1" preserveAspectRatio="xMinYMin meet">
                    <circle className="ist-circular-bar-bg" r="42" cx={r} cy={r} strokeDasharray={circlePi} strokeDashoffset="0"></circle>
                    <circle className="ist-circular-bar" r="42" cx={r} cy={r} strokeDasharray={circlePi} strokeDashoffset={offset} transform={`rotate(-90.1 ${r} ${r})`}></circle>
                </svg>
            </div>
        </div>
    )

}

export default CircularLoader;
